/**
 * Escapes HTML special characters so user-controlled text can be safely
 * embedded in strings that are ultimately rendered with `v-html`
 * (e.g. `Snackbar.vue` renders `snackbar.text` as HTML).
 */
export function escapeHtml(value: string): string {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
